import React from 'react';
import Header from './components/Header';
import AllTab from './containers/AllTab';
import EasyPayTab from './containers/EasyPayTab';
import TransactionsTab from './containers/TransactionsTab';
import { useSearchParams, useUpdateSearchParams } from 'hooks';

const TransactionsListV2 = () => {
  const params = useSearchParams();
  const currentTab = params.get('active_tab') ?? '';
  const updateSearchParams = useUpdateSearchParams();

  const changeTab = (tab: string) => {
    updateSearchParams({ active_tab: tab });
  };

  return (
    <div>
      <Header currentTab={currentTab} changeTab={changeTab} />
      <div className="pageWrapper">
        {(currentTab === '' || currentTab === 'all') && <AllTab />}
        {currentTab === 'transactions' && <TransactionsTab />}
        {currentTab === 'easy_pay' && <EasyPayTab />}
      </div>
    </div>
  );
};

export default TransactionsListV2;
